module.exports = __webpack_public_path__ + "static/media/planera.58f6db16.mp3";